<template>
  <div class="background">
    <div class="left" @click="leftClick()">前一天</div>
    <div class="right" @click="rightClick()">后一天</div>
    <div id="main"></div>
  </div>
</template>

<script>
  import * as echarts from 'echarts';
  export default {
    name: 'Duration',
    components: {
    },
    data () {
      return {
        baseUrl: 'http://goc6.com',
        fromTime: new Date(new Date().toLocaleDateString()).getTime()
      }
    },
    mounted () {
      this.inits ();
    },
    methods: {
      leftClick () {
        this.fromTime = this.fromTime - 24*3600*1000;
        this.inits ();
      },
      rightClick () {
        this.fromTime = this.fromTime + 24*3600*1000;
        this.inits ();
      },
      inits () {
        let fromTime = this.fromTime;
        let toTime = fromTime+24*3600*1000;
        const url = this.baseUrl + "/front/time/list?startTime="+fromTime+"&endTime="+toTime+"&player="+localStorage.getItem("player");
        let that = this;
        this.$axios.get(url, {
        }).then(function (response) {
          that.score = response.data.score;
          that.initCharts(response.data.timingList || [], fromTime);
        })
      },
      initCharts (result, fromTime) {

        let that = this;
        var fromDate = new Date(fromTime);
        var chartDom = document.getElementById('main');
        var myChart = echarts.init(chartDom);

        var data = [];
        var dataCount = 10;
        var startTime = fromTime;
        var categories = ['categoryA'];
        var types = {
          bule: '#7b9ce1',
          green: '#72b362',
          red: '#bd6d6c'
        }

        var t = ['#7b9ce1',
          '#bd6d6c',
          '#75d874',
          '#e0bc78',
          '#dc77dc',
          '#72b362'
        ];
        // Generate mock data
        result.forEach(function (category, index) {
          let s = new Date(category.startTime);
          let e = new Date(category.endTime);
          data.push({
            name: category.title,
            value: [1, category.startTime, category.endTime, category.periodFormat +" "+
            s.getHours()+":"+s.getMinutes()+":"+s.getSeconds()+"-"+
            e.getHours()+":"+e.getMinutes()+":"+e.getSeconds()],
            itemStyle: {
              normal: {
                color: types[category.color]
              }
            }
          });
        });
        var option = {
          tooltip: {
            formatter: function (params) {
              return params.marker + params.name + ': ' + params.value[3];
            }
          },
          title: {
            text: fromDate.getFullYear()+"-"+(fromDate.getMonth()+1)+"-"+fromDate.getDate()
            +"  S:"+ that.score ,
            left: 'center'
          },
          dataZoom: [
            {
              type: 'slider',
              filterMode: 'weakFilter',
              showDataShadow: false,
              top: 400,
              labelFormatter: ''
            },
            {
              type: 'inside',
              filterMode: 'weakFilter'
            }
          ],
          grid: {
            height: 300
          },
          xAxis: {
            min: startTime,
            scale: true,
            axisLabel: {
              formatter: function (val) {
                let das = new Date(val);
                return das.getHours()+":"+das.getMinutes()+"";//Math.max(0, val - startTime) + ' mss';
              }
            }
          },
          yAxis: {
            data: categories
          },
          series: [
            {
              type: 'custom',
              renderItem: function renderItem(params, api) {
                var categoryIndex = api.value(0);
                var start = api.coord([api.value(1), categoryIndex]);
                var end = api.coord([api.value(2), categoryIndex]);
                var height = api.size([0, 1])[1] * 0.2;
                var rectShape = echarts.graphic.clipRectByRect(
                  {
                    x: start[0],
                    y: start[1] - height / 2,
                    width: end[0] - start[0],
                    height: height
                  },
                  {
                    x: params.coordSys.x,
                    y: params.coordSys.y,
                    width: params.coordSys.width,
                    height: params.coordSys.height
                  }
                );
                return (
                  rectShape && {
                    type: 'rect',
                    transition: ['shape'],
                    shape: rectShape,
                    style: api.style()
                  }
                );
              },
              itemStyle: {
                opacity: 0.8
              },
              encode: {
                x: [1, 2],
                y: 0
              },
              data: data
            }
          ]
        };
        option && myChart.setOption(option);

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body { height: 100%; width: 100%;Font-size: 25%}
  .background{
    /*background-image: url("https://t7.baidu.com/it/u=1297102096,3476971300&fm=193&f=GIF");*/
    height: 100%;
    width: 100%;
    background-size: cover;
    position: absolute;
  }

  /*{ "position": "absolute", "width":"100%", "height":"100%", "background-size": "100% 100%", "background-repeat": "no-repeat", "background-image": "url('http://4et.oss-cn-beijing.aliyuncs.com/4et/item/61/bg.png')" }
*/
  #main{
    position: absolute;
    width: 100%;
    height: 80%;
    top: 20%;
    color: rgb(61, 50, 39);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
  }
  .left {
    position: absolute;
    width: 30%;
    top: 10%;
    left: 20%;
    color: rgb(61, 50, 39);
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
  }
  .right {
    position: absolute;
    width: 30%;
    top: 10%;
    left: 50%;
    color: rgb(61, 50, 39);
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
  }
  .thing {
    position: absolute;
    width: 40%;
    top: 30%;
    left: 30%;
    color: rgb(61, 50, 39);
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
  }

  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/game/Duration.vue